export default __webpack_public_path__ + "static/by-1d118c01f3d87d977422d0c497a0866e.jpg";